import Box from '@mui/material/Box'
import errorSvg from 'assets/svg/error.svg'

const Oops = () => {
  return (
    <Box
      component='img'
      sx={{
        height: 'auto',
        width: '22rem',
        margin: '3rem auto',
      }}
      alt='error'
      src={errorSvg}
    />
  )
}

export default Oops
